import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07f2227d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = {
  key: 0,
  class: "lingo-modal-header"
}
const _hoisted_4 = { class: "lingo-modal-title" }
const _hoisted_5 = { class: "lingo-modal-title-row" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13 1L1 13M1 1L13 13",
    stroke: "#98A2B3",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "lingo-modal-body" }
const _hoisted_12 = {
  key: 1,
  class: "lingo-modal-footer"
}

import { ref, computed, watch, onMounted, onBeforeUnmount, nextTick } from "vue";
import MedalIcon from '@/components/icons/MedalIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LingoModalComponent',
  props: {
  modelValue: { type: Boolean, required: true }, // v-model:value
  title: { type: String, default: "" },
  subtitle: { type: String, default: "" },
  // allow string (url/key) or a component (imported SVG as component / Heroicon)
  icon: { type: [String, Object, Function] as any, default: "" },
  iconAlt: { type: String, default: "" },
  size: { type: String as () => "sm" | "md" | "lg" | "full" | "640", default: "md" },
  closeOnOverlay: { type: Boolean, default: true },
  closeOnEsc: { type: Boolean, default: true },
  showCloseButton: { type: Boolean, default: true },
  centered: { type: Boolean, default: false }
},
  emits: ["update:modelValue", "close"],
  setup(__props, { emit }) {

const props = __props;





const finalIcon = computed(() => {
  if (props.icon) return props.icon;
  return MedalIcon;
});

const dialogRef = ref<HTMLElement | null>(null);
const previousBodyOverflow = ref<string | undefined>(undefined);

const sizeClass = computed(() => {
  switch (props.size) {
    case "sm":
      return "lingo-modal-sm";
    case "lg":
      return "lingo-modal-lg";
    case "full":
      return "lingo-modal-full";
    case "640":
      return "lingo-modal-640";
    case "md":
    default:
      return "lingo-modal-md";
  }
});

function lockBodyScroll() {
  previousBodyOverflow.value = document.body.style.overflow;
  document.body.style.overflow = "hidden";
}

function restoreBodyScroll() {
  if (previousBodyOverflow.value !== undefined) {
    document.body.style.overflow = previousBodyOverflow.value || "";
    previousBodyOverflow.value = undefined;
  }
}

async function open() {
  lockBodyScroll();
  await nextTick();
  const el = dialogRef.value as HTMLElement | null;
  if (el) {
    el.setAttribute("tabindex", "-1");
    el.focus();
  }
}

function onClosed() {
  restoreBodyScroll();
}

function close() {
  emit("update:modelValue", false);
  emit("close");
  // onClosed will run via watcher
}

function onOverlayClick() {
  if (!props.closeOnOverlay) return;
  close();
}

function onKeydown(e: KeyboardEvent) {
  if (!props.closeOnEsc) return;
  if (e.key === "Escape" || e.key === "Esc") {
    if (props.modelValue) close();
  }
}

watch(
  () => props.modelValue,
  (val) => {
    if (val) open();
    else onClosed();
  }
);

onMounted(() => {
  if (props.modelValue) open();
  if (props.closeOnEsc) document.addEventListener("keydown", onKeydown);
});

onBeforeUnmount(() => {
  if (props.closeOnEsc) document.removeEventListener("keydown", onKeydown);
  restoreBodyScroll();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "lingo-modal-fade" }, {
    default: _withCtx(() => [
      (__props.modelValue)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "lingo-modal-overlay",
            onClick: _withModifiers(onOverlayClick, ["self"]),
            role: "presentation"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["lingo-modal", [sizeClass.value, { 'lingo-modal-centered': __props.centered }]]),
              role: "dialog",
              "aria-modal": "true",
              "aria-label": __props.title || 'Dialog',
              ref_key: "dialogRef",
              ref: dialogRef
            }, [
              (_ctx.$slots.header || __props.title || __props.showCloseButton)
                ? (_openBlock(), _createElementBlock("header", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _renderSlot(_ctx.$slots, "header", {}, () => [
                        _createElementVNode("div", _hoisted_5, [
                          (finalIcon.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "lingo-modal-icon-container",
                                "aria-hidden": "true",
                                onClick: close
                              }, [
                                (finalIcon.value && typeof finalIcon.value !== 'string')
                                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(finalIcon.value), {
                                      key: 0,
                                      class: "lingo-modal-icon"
                                    }))
                                  : (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      src: String(finalIcon.value),
                                      alt: __props.iconAlt || '',
                                      class: "lingo-modal-icon"
                                    }, null, 8, _hoisted_6))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("h2", {
                            class: _normalizeClass(["lingo-modal-title-text", { 'lingo-modal-has-subtitle': __props.subtitle }]),
                            innerHTML: __props.title
                          }, null, 10, _hoisted_7),
                          (__props.subtitle)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 1,
                                class: "lingo-modal-subtitle-text",
                                innerHTML: __props.subtitle
                              }, null, 8, _hoisted_8))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    (__props.showCloseButton)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "lingo-modal-close",
                          type: "button",
                          onClick: close,
                          "aria-label": "Close"
                        }, _hoisted_10))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _renderSlot(_ctx.$slots, "default")
              ]),
              (_ctx.$slots.footer)
                ? (_openBlock(), _createElementBlock("footer", _hoisted_12, [
                    _renderSlot(_ctx.$slots, "footer")
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_2)
          ], 8, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})